module.exports = __webpack_public_path__ + "static/media/19.ce4b861d.png";